import React from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button 
} from '@mui/material';
import { Sync, AutoFixHigh } from '@mui/icons-material';
import ComparisonView from '../../../components/ComparisonView.js';
import ErrorSuccessAlerts from './ErrorSuccessAlerts.js';

const TextImportTab = ({
  pasteContent,
  setPasteContent,
  isProcessing,
  handlePasteSubmit,
  showComparison,
  parsedLines,
  inventory,
  setRecipeData,
  setShowComparison,
  error,
  success
}) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="body1" gutterBottom>
        Paste or write your recipe below.
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={6}
        value={pasteContent}
        onChange={(e) => setPasteContent(e.target.value)}
        placeholder="Paste or write your recipe here..."
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        onClick={handlePasteSubmit}
        disabled={!pasteContent.trim() || isProcessing}
        startIcon={isProcessing ? <Sync sx={{ animation: 'spin 1s linear infinite' }} /> : <AutoFixHigh />}
      >
        {isProcessing ? 'Processing...' : 'Process'}
      </Button>

      {showComparison && parsedLines && parsedLines.length > 0 ? (
        <ComparisonView
          parsedLines={parsedLines}
          inventory={inventory || []}
          onAccept={(editedLines) => {
            const newRecipeData = {
              name: editedLines.find(l => l.type === 'name')?.parsed.value || '',
              origin: 'My Recipes',
              description: editedLines
                .filter(l => l.type === 'description')
                .map(l => l.parsed.value)
                .join('\n'),
              ingredients: editedLines
                .filter(l => l.type === 'ingredient')
                .map(l => ({
                  name: l.parsed.name,
                  amount: l.parsed.amount,
                  unit: l.parsed.unit,
                  ingredientId: inventory.find(i =>
                    i.name.toLowerCase() === l.parsed.name.toLowerCase()
                  )?.id || ''
                })),
              instructions: editedLines
                .filter(l => l.type === 'instruction')
                .map(l => l.parsed.value)
                .join('\n'),
              garnish: editedLines
                .filter(l => l.type === 'garnish')
                .map(l => l.parsed.value)
                .join(', '),
              glass: editedLines
                .filter(l => l.type === 'glass')
                .map(l => l.parsed.value)
                .join(', ')
            };
            setRecipeData(newRecipeData);
            setShowComparison(false);
          }}
          onEdit={(editedLines) => {
            const newRecipeData = {
              name: editedLines.find(l => l.type === 'name')?.parsed.value || '',
              origin: 'My Recipes',
              description: editedLines
                .filter(l => l.type === 'description')
                .map(l => l.parsed.value)
                .join('\n'),
              ingredients: editedLines
                .filter(l => l.type === 'ingredient')
                .map(l => ({
                  name: l.parsed.name,
                  amount: l.parsed.amount,
                  unit: l.parsed.unit,
                  ingredientId: inventory.find(i =>
                    i.name.toLowerCase() === l.parsed.name.toLowerCase()
                  )?.id || ''
                })),
              instructions: editedLines
                .filter(l => l.type === 'instruction')
                .map(l => l.parsed.value)
                .join('\n'),
              garnish: editedLines
                .filter(l => l.type === 'garnish')
                .map(l => l.parsed.value)
                .join(', '),
              glass: editedLines
                .filter(l => l.type === 'glass')
                .map(l => l.parsed.value)
                .join(', ')
            };
            setRecipeData(newRecipeData);
            setShowComparison(false);
          }}
        />
      ) : showComparison && (
        <Typography variant="body2" sx={{ color: 'warning.main', mt: 2 }}>
          No recipe lines were parsed. Please try again.
        </Typography>
      )}

      <ErrorSuccessAlerts error={error} success={success} />
    </Box>
  );
};

export default TextImportTab; 